import {Component, ViewEncapsulation, ChangeDetectorRef, OnInit, AfterViewInit} from '@angular/core';
import {SharedHelper} from "./helpers/shared.helper";
import {DialogService} from "./services/dialog.service";
import {ApiService} from "./services/api.service";
import {SpinnerService} from './services/spinner.service';
import {DragDropHelper} from "./helpers/drag-drop.helper";
import { AnalyticsHelper } from './helpers/analytics.helper';
import {NavigationEnd, Router} from "@angular/router";

declare var gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit {
  title = 'les-maitres-a-panser';
  show_spinner = false;
  is_home_page= false;
  private eventListenersAdded = false;

  constructor(
    public router: Router,
    public sharedHelper: SharedHelper,
    public dragDropHelper: DragDropHelper,
    public analyticsHelper: AnalyticsHelper,
    public dialogService: DialogService,
    public spinnerService: SpinnerService,
    public apiService: ApiService,
    private cdr: ChangeDetectorRef,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.is_home_page = event.urlAfterRedirects === '/' || event.urlAfterRedirects === '';
      }
    });
  }

  ngAfterViewChecked() {
    if (!this.eventListenersAdded) {
      this.addEventListenersToLinks(this.analyticsHelper);
    }
  }

  ngOnInit() {
    this.analyticsHelper.initialize();
    this.spinnerService.spinner$.subscribe(hide => {
      this.show_spinner = hide;
    });
  }

  addEventListenersToLinks(analyticsHelper: AnalyticsHelper) {
    const links = document.querySelectorAll('.doc-download');
    //console.log('DOM fully loaded and parsed', links);  // Check if this logs
    if(links.length === 0) {
      return;
    }
    links.forEach(link => {
      link.removeEventListener('click', (e) => this.handleLinkClick(e, analyticsHelper));
      link.addEventListener('click', (e) => this.handleLinkClick(e, analyticsHelper));
    });
    this.eventListenersAdded = true;
  }

  handleLinkClick(event: Event, analyticsHelper: AnalyticsHelper) {
    let target = event.target as HTMLElement;

    // Traverse up the DOM tree to find the closest parent <a> element
    while (target && target.tagName !== 'A') {
      target = target.parentElement as HTMLElement;
    }

    if (target) {
      const documentId = target.getAttribute('data-document-id');
      console.log('documentId', documentId);
      analyticsHelper.addDownloadEvent(documentId, "PDF");
    }
  }

  // ngAfterViewInit() {
  //   // Manually trigger change detection
  //   this.cdr.detectChanges();
  // }
}
